import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { IMultiCountry } from "../interfaces/imulticountry";
import { Observable } from "rxjs";
import { CountryComparisonService } from "../services/countrycomparison.service";

@Injectable()
export class MultiCountryResolver {

    constructor(private countryComparisionService: CountryComparisonService) {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<IMultiCountry> {
        return this.countryComparisionService.getMultiCountry('AL');
    }
}